/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_N3Inputs */

const en_minifier_ref_n3 = /** @type {(inputs: Minifier_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline after gzip. Compression alone beats minification by a wide margin.`)
};

const ko_minifier_ref_n3 = /** @type {(inputs: Minifier_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기준값에 gzip을 적용한 것입니다. 압축만으로도 압축기보다 훨씬 앞섭니다.`)
};

const ja_minifier_ref_n3 = /** @type {(inputs: Minifier_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基準値に gzip をかけたものです。圧縮だけで圧縮ツールを大きく上回ります。`)
};

/**
* | output |
* | --- |
* | "Baseline after gzip. Compression alone beats minification by a wide margin." |
*
* @param {Minifier_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_n3 = /** @type {((inputs?: Minifier_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_n3(inputs)
	if (locale === "ko") return ko_minifier_ref_n3(inputs)
	return ja_minifier_ref_n3(inputs)
});